import { PackageCurrency } from 'types/enums/PackageCurrency';
import { PackageDuration } from 'types/enums/PackageDuration';

const CURRENCY_SYMBOLS = {
  [PackageCurrency.USD]: '$',
  [PackageCurrency.CAD]: '$',
  [PackageCurrency.AUD]: '$',
  [PackageCurrency.NZD]: ' $',
  [PackageCurrency.GBP]: '£',
  [PackageCurrency.EUR]: ' €',
  [PackageCurrency.SEK]: ' kr',
  [PackageCurrency.NOK]: ' kr',
  [PackageCurrency.DKK]: ' kr',
  [PackageCurrency.PLN]: ' zł',
};

const DURATION_LABELS_KEYS = {
  [PackageDuration.PerDay]: 'day',
  [PackageDuration.PerMonth]: 'month',
  [PackageDuration.PerYear]: 'year',
} as const;

export const roundToTwoDigits = (value: number) =>
  (Math.round(value * 100) / 100).toFixed(2);

export const getCurrencySymbol = (currency: PackageCurrency) => {
  return CURRENCY_SYMBOLS[currency] ?? '';
};

export const getDurationLabelKey = (
  duration: PackageDuration
): (typeof DURATION_LABELS_KEYS)[keyof typeof DURATION_LABELS_KEYS] => {
  return DURATION_LABELS_KEYS[duration] ?? '';
};

export const getOneCreditPrice = (packPrice: string, creditAmount: number) => {
  const value = parseFloat(packPrice) / creditAmount;
  return value.toFixed(2);
};

export const isKroneCurrency = (currency?: PackageCurrency) => {
  if (!currency) {
    return false;
  }

  return [
    PackageCurrency.SEK,
    PackageCurrency.NOK,
    PackageCurrency.DKK,
    PackageCurrency.PLN,
  ].includes(currency);
};

export const applyCurrencySymbol = (
  value: string | number,
  currency: PackageCurrency
) => {
  const currencySymbol = getCurrencySymbol(currency);

  return isKroneCurrency(currency)
    ? `${value} ${currencySymbol}`
    : `${currencySymbol}${value}`;
};

export const getPriceAfterDiscount = (price: number, discount = 0) => {
  if (!discount) {
    return price;
  }

  if (!price && price !== 0) {
    throw new Error("'value' must be specified");
  }

  return price - price * (discount * 0.01);
};

export const getPriceByDuration = (price: number, period = 1) => price / period;

export const getCurrencySymbolByLocale = (currency: PackageCurrency) => {
  return currency === PackageCurrency.AUD ||
    currency === PackageCurrency.CAD ||
    currency === PackageCurrency.USD
    ? getCurrencySymbol(currency)
    : currency;
};
